<script>
export default {
  inheritAttrs: false,
  model: {
    event: 'update',
  },
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'checkbox',
      validator(value) {
        return ['checkbox'].includes(value)
      },
    },
  },
}
</script>

<template>
  <input
    :type="type"
    :class="{ [$style.input]: true, [$style.checked]: checked }"
    v-bind="$attrs"
    :checked="checked"
    v-on="$listeners"
  />
</template>

<style lang="scss" module>
@import '@design';

.input {
  height: 20px;
  width: 20px;
}
</style>
